import { createFileRoute, redirect } from "@tanstack/react-router";
import { customersQueries } from "../../../shared/queries/customers.queries";
import { RouteError } from "../../../shared/components/RouteError";

export const Route = createFileRoute("/app/admin/bike-models")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  // BEL-762: this legacy link carries no customer of its own. With exactly
  // one customer reachable, go straight there; with more than one, land on
  // `/app`, the existing customer-picker screen — never guess. The system
  // customer (`isSystem`) is bookkeeping, not a customer anyone manages
  // bike models for, so it doesn't count toward "how many can this user
  // reach".
  beforeLoad: async ({ context }) => {
    const allCustomers = await context.queryClient.ensureQueryData(
      customersQueries.list(),
    );
    const customers = allCustomers.filter((c) => !c.isSystem);
    if (customers.length === 1) {
      throw redirect({
        to: "/app/c/$customerSlug/bike-models",
        params: { customerSlug: customers[0]!.slug },
        replace: true,
      });
    }
    throw redirect({ to: "/app" });
  },
});
